import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useOutletContext } from "react-router";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";

import { ShopDashboardContainer } from "./styled";

import OrderStatus from "./mypage/orderStatus";
import ProductList from "./mypage/productList";
import { calcPrice } from "../../common/function/shopping";
import { FaAngleRight } from "react-icons/fa6";

const ShopDashboard = () => {
  const navigate = useNavigate();
  const { url } = useOutletContext();
  const user = useSelector((state) => state?.user?.data[0]);
  const [data, setData] = useState([]);
  const [cartData, setCartData] = useState([]);

  useEffect(() => {
    if (!user) return;
    getOrders();
    getCart();
  }, []);

  const getCart = async () => {
    const url = "/erp/cart/get";
    const body = { mberNo: user.mberNo, platform: "MULTI_PAGE" };

    try {
      const { data } = await axios.post(url, body);

      if (data) {
        setCartData(
          (data || []).map((item) => {
            const parsed = JSON.parse(item.productImageUrl);
            const url = Array.isArray(parsed) ? parsed[0] : parsed;

            return {
              media: url ? url : "",
              totalPrice: calcPrice(item),
              productName: item.productName,
            };
          }),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrders = async () => {
    try {
      const body = {
        filter: {
          fromDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
          mberNo: user?.mberNo,
        },
      };

      const { data } = await axios.post("/erp/customerOrders", body);
      setData(data);
    } catch (err) {
      console.error("주문 조회 실패", err);
    }
  };

  // 중복 제거된 최근 상품 4개 추출
  const recentProducts = useMemo(() => {
    if (!data?.orders) return [];

    const allProducts = data.orders.flatMap(
      (order) => order.subOrders?.flatMap((sub) => sub.products || []) || [],
    );

    const uniqueByProductId = new Map();
    for (const product of allProducts) {
      if (!uniqueByProductId.has(product.productId)) {
        uniqueByProductId.set(product.productId, product);
      }
    }

    return Array.from(uniqueByProductId.values()).slice(0, 4);
  }, [data]);

  return (
    <ShopDashboardContainer>
      <OrderStatus data={data} />
      <ProductList
        label="장바구니"
        products={cartData}
        // products={[]}
        action={{
          label: "더보기",
          icon: FaAngleRight,
          className: "wish",
          clickEvent: () => navigate(`/shop/mypage/cart`),
        }}
      />
      <ProductList
        label="최근 주문 상품"
        products={recentProducts}
        // products={[]}
        action={{
          label: "더보기",
          icon: FaAngleRight,
          className: "wish",
          clickEvent: () => navigate(`/shop/mypage/history`),
        }}
      />
    </ShopDashboardContainer>
  );
};

export default ShopDashboard;
